<template>
  <div class="index-page">
    <div class="page-header">
      <div class="header-1280">
        <img class="header-logo" src="../../public/static/indexUse/logo3.svg" />
        <template v-if="isMobile">
          <div class="change-lang" @click="changeLang">
            {{ nowLang }}
          </div>
          <a-popover trigger="click" placement="bottomRight" v-model:open="menuPop">
            <div class="menu-mobile">
              <dol-icon type="MenuOutlined" />
            </div>
            <template #content>
              <a-menu v-model:openKeys="openKeys" v-model:selectedKeys="selectedKeys"
                      :items="menuMobile" mode="inline" style="width: 200px" @click="menuClick" />
            </template>
          </a-popover>
        </template>
        <div class="header-right" v-else>
          <div class="change-lang" @click="changeLang">
            {{ nowLang }}
          </div>
          <div class="header-menu">
            <template v-for="menu in menuListServer">
              <div v-if="menu.type === 'page'"
                   class="menu-item"
                   :class="{'active-menu': menuActive.path === menu.link || menuActive.path === menu._id || menuActive.parentId === menu._id}"
                   @click="goPage(menu)">
                {{ $dt(menu, 'name') }}
              </div>
              <a-dropdown v-if="menu.type === 'menu'" placement="bottomRight">
                <div class="menu-item" :class="{'active-menu': menuActive.parentId === menu._id}">
                  {{ $dt(menu, 'name') }}
                </div>
                <template #overlay>
                  <a-menu>
                    <a-menu-item v-for="page in menu.children" :key="page._id" @click="goPage(page)">
                      <div class="menu-item-row"
                           :class="{'active-sub-menu': menuActive.path === page.link || menuActive.path === page._id}">
                        {{ $dt(page, 'name') }}
                      </div>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="page-body" ref="pageBody">
      <router-view @scrollToTop="scrollToTop"/>
      <div class="footer-box">
        <div class="footer-container">
          <img class="footer-logo" src="../../public/static/indexUse/logo2.png" />
          <div class="footer-left">
            <div class="school-name">{{ $t('上海松江区爱菊学校') }}</div>
            <div class="school-info">{{ $t('首页地址') }}</div>
          </div>
          <div class="footer-right" :style="$i18n.locale === 'en'?{gap:'24px'}:{}" v-if="!isMobile">
            <div v-for="item in footerList" :key="item._id" class="footer-column">
              <div class="column-title">{{ $dt(item, 'name') }}</div>
              <div v-for="page in item.pageArr" :key="page._id" class="column-item"
                   @click="$router.push(page.link || page._id)">
                {{ $dt(page, 'name') }}
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="footer-divider"></div>
          <div class="record-info-row">
            <a target="_blank" class="record-info"
               href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011702891376">
              <img src="../../public/static/beian.png" style="margin-right: 4px" />
              沪公网安备 31011702891376号
            </a>
            <a target="_blank" class="record-info" href="http://beian.miit.gov.cn">沪ICP备12043526号-2</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const mobileMediaQuery = window.matchMedia('(max-width: 991px)');

export default {
  name: "index",
  data() {
    return {
      footerList: [],
      menuPop: false,
      openKeys: [],
      selectedKeys: [],
    };
  },
  watch: {
    $route(to, from) {
      this.makeMobileMenuPickRight();
    }
  },
  computed: {
    nowLang() {
      return this.$i18n.locale === 'zh' ? 'English' : '简体中文';
    },
    menuListServer() {
      const menuList = this.$store.state.app.menuList.filter(item => item.showFlag);
      menuList.forEach(menu => {
        if (!menu.children || !menu.children.length) return;
        menu.children = menu.children.filter(item => item.showFlag);
      });
      return menuList;
    },
    menuMap() {
      const map = {}, menuList = this.$store.state.app.menuList;
      menuList.forEach(menu => {
        map[menu._id] = menu;
        if (menu.children && menu.children.length) {
          menu.children.forEach(child => map[child._id] = child);
        }
      });
      return map;
    },
    menuMobile() {
      const menuList = this.$store.state.app.menuList.filter(item => item.showFlag);
      // console.log(menuListServer)
      return menuList.map(menu => {
        const nowItem = { key: menu._id, label: this.$dt(menu, 'name') };
        if (menu.type === 'menu' && menu.children) {
          const children = menu.children.filter(child => child.showFlag);
          if (children.length) {
            nowItem.children = menu.children.map(item => ({
              key: item._id,
              label: this.$dt(item, 'name')
            }));
          }
        }
        return nowItem;
      });
    },
    menuActive() {
      return this.$store.state.app.menuActive || { path: 'no' };
    },
    isMobile() {
      return this.$store.state.app.isMobile;
    }
  },
  methods: {
    scrollToTop(){
      // 滚动到顶部
      this.$nextTick(() => {
        setTimeout(() => {
          // this.$refs.topBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
          this.$refs.pageBody.scrollTo({ top: 0, behavior: 'smooth' });
        }, 10);
      });
    },
    menuClick({ key }) {
      const menu = this.menuMap[key];
      this.menuPop = false;
      this.goPage(menu);
    },
    changeLang() {
      this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh';
    },
    goPage(menu) {
      if (menu.type === 'page') {
        this.$router.push(menu.link || menu._id);
      }
    },
    queryFooter() {
      this.$ajax({ url: '/portal/portalFooterFind', }).then(({ rows }) => {
        this.footerList = rows;
      });
    },
    updateIsMobile(e) {
      this.$store.commit('app/setIsMobile', e.matches);
    },
    makeMobileMenuPickRight() {
      const pageMap = this.$store.state.app.pageMap;
      const nowPath = this.$route.path.replace('/', '');
      this.selectedKeys = [pageMap[nowPath]?._id];
    }
  },
  created() {
    this.queryFooter();
  },
  mounted() {
    this.updateIsMobile(mobileMediaQuery);
    mobileMediaQuery.addEventListener('change', this.updateIsMobile);
    this.makeMobileMenuPickRight();
  }
};
</script>

<style lang="scss">
@use '../assets/scss/constant' as constant;

.menu-item-row {
  text-align: center;
  padding: 4px 12px;

  &.active-sub-menu {
    color: #D93379;
    font-weight: bold;
  }
}

.index-page {
  width: 100%;
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;

  .page-header {
    width: 100%;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);

    .header-1280 {
      width: 1280px;
      margin: auto;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .header-logo {
        height: 52px;
        width: auto;
        object-fit: contain;
      }

      .header-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
      }

      .header-menu {
        display: flex;
        align-items: center;
        gap: 36px;

        .menu-item {
          font-size: 16px;
          color: #003C82;
          cursor: pointer;
          transition: color 0.3s ease;
          white-space: nowrap;
          line-height: 40px;
          font-weight: bold;

          &:hover {
            color: #D93379;
          }

          &.active-menu {
            color: #D93379;
            font-weight: 500;
          }
        }

      }

      .change-lang {
        font-size: 14px;
        color: #003C82;
        cursor: pointer;
        white-space: nowrap;
        line-height: 40px;
        font-weight: bold;
      }
    }
  }

  .page-body {
    width: 100%;
    flex: 1;
    overflow-y: auto;
  }

  .footer-box {
    width: 100%;
    background: #002250;
    padding: 60px 0 30px;
    box-sizing: border-box;

    .footer-container {
      width: 1280px;
      margin: 0 auto;
      display: flex;

      .footer-logo {
        height: 96px;
        width: 96px;
        margin-right: 24px;
      }

      .footer-left {
        flex: 1;

        .school-name {
          font-weight: bold;
          color: #fff;
          line-height: 20px;
          margin-bottom: 16px;
        }

        .school-info {
          color: #BCBCBC;
          line-height: 18px;
          margin-bottom: 16px;
          white-space: pre-wrap;
        }
      }

      .footer-right {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        gap: 68px;

        .footer-column {

          .column-title {
            font-weight: bold;
            color: #fff;
            line-height: 20px;
            margin-bottom: 16px;
            white-space: nowrap;
          }

          .column-item {
            color: #BCBCBC;
            line-height: 20px;
            margin-bottom: 16px;
            white-space: nowrap;
            cursor: pointer;

            &:hover {
              color: #fff;
            }
          }
        }
      }
    }

    .footer-bottom {
      width: 1280px;
      margin: 40px auto 0;

      .footer-divider {
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.2);
        margin-bottom: 24px;
      }

      .record-info-row {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 32px;

        .record-info {
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 14px;
          opacity: 0.7;
          text-decoration: none;
        }
      }
    }
  }
}

// PC端
@media (min-width: #{constant.$mobileMaxWidth + 1}) {
  .index-page {
    //font-weight: bold;
    .page-header {
      height: 80px;
    }
  }
}

// 移动端
@media (max-width: constant.$mobileMaxWidth) {
  .ant-menu-item-selected {
    color: #D93379 !important;
    background-color: rgba(#D93379, 0.1) !important;
  }
  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    color: #D93379 !important;
  }
  .index-page {
    .page-header {
      height: 60px;

      .header-1280 {
        width: 100%;
        padding-left: 24px;

        .header-logo {
          height: 32px;
        }

        .change-lang {
          font-size: 14px;
          color: #003C82;
          cursor: pointer;
          white-space: nowrap;
          line-height: 40px;
          font-weight: bold;
        }

        .menu-mobile {
          background: #D93379;
          color: white;
          height: 60px;
          line-height: 60px;
          width: 60px;
          text-align: center;
          font-size: 24px;
        }
      }
    }

    .footer-box {
      //width: 100vw;
      padding: 36px 0 24px;

      .footer-container {
        //width: 100vw;
        width: 100%;
        padding: 0 24px;

        .footer-left {
          .school-name {
            margin-bottom: 10px;
          }

          .school-info {
            line-height: 14px;
            margin-bottom: 10px;
          }
        }
      }

      .footer-bottom {
        //width: 100vw;
        width: 100%;
        margin: 4px auto 0;

        .footer-divider {
          margin-bottom: 12px;
        }

        .record-info-row {
          flex-direction: column;
          gap: 8px;
        }
      }
    }
  }
}
</style>
